import { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import DataTable from 'examples/Tables/DataTable';
import { toast } from 'react-toastify';

import { propertyColumns, propertyRows } from './data';
import { getRecentProperty } from 'services/dashboard.service';

function RecentProperties() {
  const [recentlyAddedProperty, setRecentlyAddedProperty] = useState([]);
  const [tableLoader, setTableLoader] = useState(false)
  // API Integration
  const fetchRecentlyAddedProperty = async () => {
    setTableLoader(true)
    try {
      const res = await getRecentProperty();
      if (!res.isError) {
        setRecentlyAddedProperty(res.data?.properties);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      const { response } = error;
      toast.error(response?.data?.message);
    }
    setTableLoader(false)
  };
  useEffect(() => {
    fetchRecentlyAddedProperty();
  }, []);

  return (
    <Card>
      <MDBox p={3}>
        <MDTypography variant="h6" gutterBottom>
          Recently Added Properties
        </MDTypography>
      </MDBox>
      <MDBox>
        <DataTable
          table={{
            columns: propertyColumns,
            rows: propertyRows(recentlyAddedProperty),
          }}
          showTotalEntries={false}
          noEndBorder
          isLoading={tableLoader}
          entriesPerPage={false}
        />
      </MDBox>
      <MDBox p={3} align="right">
        <MDTypography
          component="a"
          href="/properties"
          variant="button"
          color="info"
          fontSize="16px"
          fontWeight="regular"
        >
          See more
        </MDTypography>
      </MDBox>
    </Card>
  );
}

export default RecentProperties;
